import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  getDsQuanLyHoSo: {
    url: `${API_URL}/ho-so-thanh-tra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietQuanLyHoSo: {
    url: `${API_URL}/ho-so-thanh-tra/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  // Danh mục nhóm hồ sơ
  getNhomHoSo: {
    url: `${API_URL}/nhom-ho-so`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postNhomHoSo: {
    url: `${API_URL}/nhom-ho-so`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putNhomHoSo: {
    url: `${API_URL}/nhom-ho-so/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteNhomHoSo: {
    url: `${API_URL}/nhom-ho-so/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
}).use('fetch', customFetch);


// WEBPACK FOOTER //
// ./src/api/quanLyHoSo.js